import { loadStripe } from '@stripe/stripe-js';

import { STRIPE_PUBLISH_KEY } from '../config-global';

export function getStripePromise(stripeAccount: string) {
  return loadStripe(STRIPE_PUBLISH_KEY, {
    stripeAccount,
  });
}
